import { render, staticRenderFns } from "./asideIcon.vue?vue&type=template&id=27f5da5f&scoped=true&"
import script from "./asideIcon.vue?vue&type=script&lang=js&"
export * from "./asideIcon.vue?vue&type=script&lang=js&"
import style0 from "./asideIcon.vue?vue&type=style&index=0&id=27f5da5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f5da5f",
  null
  
)

export default component.exports